// Runtime webpack config
import '../../other/WebpackConfig';

// i18n
import i18n from '../../i18n/nl-BE';

import carVip from './carVip';

carVip(i18n);
